import { BACKGROUND_IMAGE_URL } from '../components/trial-lockout-modal/constants/url';

import {
  startImagePreload,
  usePreloadImage,
} from './preloadImage';

type UsePreloadTrialLockoutBackgroundOptions = {
  enabled: boolean;
  imageUrl?: string;
};

export const startTrialLockoutBackgroundPreload = (
  imageUrl = BACKGROUND_IMAGE_URL
) => startImagePreload(imageUrl);

export const usePreloadTrialLockoutBackground = ({
  enabled,
  imageUrl = BACKGROUND_IMAGE_URL,
}: UsePreloadTrialLockoutBackgroundOptions) =>
  usePreloadImage({ enabled, imageUrl });

export { startImagePreload, usePreloadImage } from './preloadImage';
